<template>
  <div class="project-create-container">
    <div class="project-card">
      <h2>添加自定义项目</h2>
      <form @submit.prevent="handleSubmit">
        <div class="form-group">
          <label>项目名称 <span class="required">*</span></label>
          <input v-model="form.name" type="text" placeholder="请输入项目名称" required />
        </div>
        <div class="form-group">
          <label>项目描述</label>
          <textarea v-model="form.description" placeholder="请输入项目描述" rows="3"></textarea>
        </div>
        <div class="form-group">
          <label>项目状态 <span class="required">*</span></label>
          <select v-model="form.status" required>
            <option value="">请选择</option>
            <option value="1">在线</option>
            <option value="2">离线</option>
          </select>
        </div>
        <div class="form-group">
          <label>媒体状态 <span class="required">*</span></label>
          <select v-model="form.mediaStatus" required>
            <option value="">请选择</option>
            <option value="1">在线</option>
            <option value="0">离线</option>
          </select>
        </div>
        <div class="form-group">
          <label>项目类别 <span class="required">*</span></label>
          <select v-model="form.type" required>
            <option value="1">A类项目</option>
            <option value="2">B类项目</option>
          </select>
        </div>
        <div class="form-actions">
          <button class="submit-btn" type="submit" :disabled="loading">{{ loading ? '提交中...' : '提交' }}</button>
          <button class="cancel-btn" type="button" @click="$router.push('/app/projects')">取消</button>
        </div>
      </form>
      <div v-if="successMsg" class="success-msg">{{ successMsg }}</div>
      <div v-if="errorMsg" class="error-msg">{{ errorMsg }}</div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  name: 'ProjectCreate',
  data() {
    return {
      form: {
        name: '',
        description: '',
        status: '',
        mediaStatus: '',
        type: '1'
      },
      loading: false,
      successMsg: '',
      errorMsg: ''
    };
  },
  methods: {
    async handleSubmit() {
      this.successMsg = '';
      this.errorMsg = '';
      if (!this.form.name || !this.form.status) {
        this.errorMsg = '请填写所有必填项';
        return;
      }
      this.loading = true;
      console.log(this.form);
      try {
        // 假设后端接口为 /api/project/create，POST 方式
        //const employeeId = localStorage.getItem('employeeId');
        var url = `/api/projects/add`; //localStorage.getItem('authority') == 1 ? `/api/projects/add` : `/api/projects/addWithEmployee?employeeId=${encodeURIComponent(employeeId)}`;

        await axios.post(`${url}`, this.form);
        this.successMsg = '项目添加成功！即将跳转到列表页...';
        
        // 跳转到项目列表页
        setTimeout(() => {
          this.$router.push('/app/projects');
        }, 1500); // 延迟1.5秒跳转，让用户看到成功信息

      } catch (e) {
        this.errorMsg = '提交失败，请稍后重试';
      } finally {
        this.loading = false;
      }
    }
  }
}
</script>

<style scoped>
.project-create-container {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f0f2f5;
}
.project-card {
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 4px 16px rgba(0,0,0,0.08);
  padding: 20px 32px;
  width: 100%;
  max-width: 420px;
  margin-top: -60px;
}
.project-card h2 {
  text-align: center;
  margin-bottom: 32px;
  color: #333;
}
.form-group {
  margin-bottom: 22px;
}
.form-group label {
  display: block;
  margin-bottom: 8px;
  color: #333;
  font-size: 15px;
}
.form-group .required {
  color: #f5222d;
  font-size: 15px;
}
input[type="text"],
select,
textarea {
  width: 100%;
  padding: 10px 12px;
  border: 1px solid #d9d9d9;
  border-radius: 6px;
  font-size: 15px;
  box-sizing: border-box;
  transition: border-color 0.2s;
}
input:focus, select:focus, textarea:focus {
  outline: none;
  border-color: #1890ff;
}
.form-actions {
  display: flex;
  gap: 16px;
  justify-content: center;
  margin-top: 10px;
}
.submit-btn {
  width: 100%;
  padding: 14px 0;
  background: #1890ff;
  color: #fff;
  font-size: 17px;
  font-weight: 600;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  transition: background 0.2s;
}
.submit-btn:disabled {
  background: #b2d8ff;
  cursor: not-allowed;
}
.cancel-btn {
  background: #fff;
  color: #888;
  border: 1px solid #d9d9d9;
  border-radius: 6px;
  padding: 10px 24px;
  font-size: 15px;
  cursor: pointer;
  transition: border-color 0.2s, color 0.2s;
}
.cancel-btn:hover {
  border-color: #1890ff;
  color: #1890ff;
}
.success-msg {
  margin-top: 18px;
  color: #52c41a;
  text-align: center;
}
.error-msg {
  margin-top: 18px;
  color: #f5222d;
  text-align: center;
}
</style> 